// removed by extract-text-webpack-plugin
module.exports = {"container":"container__3fTbZ","emojiWrapper":"emojiWrapper__RVA6n","emoji":"emoji__2CfDu","emojiOpacity":"emojiOpacity__1iPvA","hidden":"hidden__BVzIg","emojiText":"emojiText__23G_r","emojiContainer":"emojiContainer__2qB9K"};


//////////////////
// WEBPACK FOOTER
// ./components/EmojiGraphFaded/style.css
// module id = h9s4
// module chunks = 0